// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 6350 ? "72a30a16" : chunkId) + "." + {"490":"84052d39ff5866d8","2442":"599d1d876fa0a7c2","6350":"4d7179ba60d8ce72","7666":"b8131232566510e6","8537":"6a6394a8a5bac7e1"}[chunkId] + ".js";
};